import { useQuery, QueryObserverBaseResult } from "react-query"
import { queryKeys } from "../query"
import api, { createUrlParams } from "../client"
import { GetUsersRequestQuery, UsersResponseData } from "../types/user"

const getData = async (getUsersRequestQuery: GetUsersRequestQuery) => {
  const { data } = await api.get(`/users${createUrlParams(getUsersRequestQuery)}`)
  return data
}

export const useUsers = (getUsersRequestQuery: GetUsersRequestQuery)
  : QueryObserverBaseResult<UsersResponseData> => {
  const { data, ...props } = useQuery<UsersResponseData>(
    queryKeys.USERS(getUsersRequestQuery),
    () => getData(getUsersRequestQuery),
  )
  return { data, ...props }
}
